import * as tslib_1 from "tslib";
import { aClientConfig } from './client-config.builder';
var AppModelBuilder = /** @class */ (function () {
    function AppModelBuilder(appModel) {
        this.topology = {
            baseDomain: '//ecom.wix.com',
            localeDatasetDataStaticUrl: '//static.parastorage.com/services/locale-dataset-data/1.18.0/',
            premiumUrl: '//premiumurl',
            frogUrl: '//frogurl/',
            checkoutStaticUrl: '',
            appSettingsClientUrl: '//localhost:3210/_api/app-settings-service',
        };
        this.experiments = {};
        this.clientConfig = aClientConfig();
        this.pageMap = {
            gallery: 'product_gallery',
            product: 'product_page',
            cart: 'shopping_cart',
            thankyou: 'thank_you_page',
        };
        this.appSettings = {};
        if (appModel) {
            Object.assign(this, JSON.parse(JSON.stringify(appModel)));
        }
    }
    AppModelBuilder.prototype.withTopology = function (topology) {
        this.topology = topology;
        return this;
    };
    AppModelBuilder.prototype.withTopologyMerge = function (topology) {
        this.topology = tslib_1.__assign({}, this.topology, topology);
        return this;
    };
    AppModelBuilder.prototype.withExperiments = function (experiments) {
        this.experiments = experiments;
        return this;
    };
    AppModelBuilder.prototype.withClientConfig = function (clientConfig) {
        this.clientConfig = clientConfig;
        return this;
    };
    AppModelBuilder.prototype.withPageMap = function (pageMap) {
        this.pageMap = pageMap;
        return this;
    };
    AppModelBuilder.prototype.withAppData = function (appData) {
        this.appData = appData;
        return this;
    };
    AppModelBuilder.prototype.withAppSettings = function (appSettings) {
        this.appSettings = appSettings;
        return this;
    };
    return AppModelBuilder;
}());
export { AppModelBuilder };
export default AppModelBuilder;
export function aAppModel(appModel) {
    return new AppModelBuilder(appModel);
}
//# sourceMappingURL=app-model.builder.js.map